<div [ngStyle]="style" *ngIf="initial">
  {{ initial }}
</div>

<div [ngStyle]="style" *ngIf="icon">
  <ion-icon [name]="icon"></ion-icon>
</div>
